import React, { useEffect, useState } from 'react';

export default function PwaUpdateNotice() {
  const [registration, setRegistration] = useState(null);
  useEffect(() => {
    const onUpdate = (event) => setRegistration(event.detail);
    window.addEventListener('quod:pwa-update', onUpdate);
    return () => window.removeEventListener('quod:pwa-update', onUpdate);
  }, []);
  if (!registration?.waiting) return null;
  const activate = () => {
    navigator.serviceWorker.addEventListener('controllerchange', () => window.location.reload(), { once: true });
    registration.waiting.postMessage({ type: 'ACTIVATE_UPDATE' });
  };
  return (
    <div role="status" data-testid="pwa-update-notice" style={{ position: 'fixed', right: 16, bottom: 16, zIndex: 100, maxWidth: 340, padding: 12, border: '1px solid var(--border)', borderRadius: 8, background: 'var(--surface, #fff)', boxShadow: '0 8px 30px rgba(15,23,42,.18)', fontSize: 13 }}>
      A Finder update is ready.
      <button type="button" className="btn btn-primary" onClick={activate} style={{ minHeight: 44, marginLeft: 10 }}>Update safely</button>
    </div>
  );
}
